export const WebSkin = Object.freeze({
	'ASIA': '1',
	'CHINA_VIEW': '2',
	'ASIA_NEW': '3',
	'VIEW188': '6'
});

export const SiteBrand = Object.freeze({
	SABA: 1,
	CV: 2
});